import '@ver-uds/styles';
import './globals.scss';
import './App.scss';

import { Banner, BannerExtension, SkipNav } from '@ver-uds/uswds-react';
import React from 'react';
import { Route } from 'react-router-dom';
import PageFooter from './components/PageFooter/PageFooter';
import SessionHandler from './components/SessionHandler';
import DashboardRoutes from './DashboardRoutes';
import DashboardHeader from './components/DashboardHeader/DashboardHeader';
import { DashboardProvider } from './context/Dashboard/DashboardContext';
import DashboardAccountNotFound from './components/Dashboard/DashboardAccountNotFound/DashboardAccountNotFound';

interface DashboardAppProps {
  isMaintenanceMode?: boolean;
  canAccessDashboard?: boolean;
}

const Content: React.FC = ({ children }) => (
  <div className="App">
    <div className="width-auto display-flex flex-column height-viewport">
      <SkipNav.Anchor />
      <Banner extensionType={BannerExtension.GOV} />
      <div className="usa-overlay" />
      <SessionHandler />
      <DashboardHeader />
      {children}
      <PageFooter />
    </div>
  </div>
);

const DashboardApp: React.FC<DashboardAppProps> = ({ isMaintenanceMode = false, canAccessDashboard = true }) => {
  return (
    <DashboardProvider>
      {canAccessDashboard ? (
        <Content>
          <DashboardRoutes isMaintenanceMode={isMaintenanceMode} />
        </Content>
      ) : (
        <Content>
          <Route path="/">
            <div className="dashboard">
              <DashboardAccountNotFound />
            </div>
          </Route>
        </Content>
      )}
    </DashboardProvider>
  );
};

DashboardApp.defaultProps = {
  isMaintenanceMode: false,
  canAccessDashboard: true,
};

export default DashboardApp;
